"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var emptyFunction = function emptyFunction() {};

var returnEmptyFunction = function returnEmptyFunction() {
  return emptyFunction;
};
/**
 * Latch
 */


var Latch = /*#__PURE__*/function () {
  /**
   * Creates a new Latch.
   */
  function Latch() {
    _classCallCheck(this, Latch);

    this.isFirstRun = true;
    this.isFinished = false;
    this.list = [];
  }
  /**
   * Takes a lock, causing execution to wait if number of callers exceeds maxCount.
   *
   * @returns {Promise} Promise resolved or not depending on if caller must wait.
   */


  _createClass(Latch, [{
    key: "aquire",
    value: function aquire() {
      if (this.isFinished) {
        return Promise.resolve().then(returnEmptyFunction);
      } else if (this.isFirstRun) {
        this.isFirstRun = false;
        return Promise.resolve().then(this._getFirstReleaseFunction.bind(this));
      } else {
        return new Promise(this._addResolveToList.bind(this)).then(returnEmptyFunction);
      }
    }
    /**
     * Add promise resolve to list.
     *
     * @param {Function} resolve Argument from Promise constructor.
     */

  }, {
    key: "_addResolveToList",
    value: function _addResolveToList(resolve) {
      this.list.push(resolve);
    }
    /**
     *
     * @returns {Function} - A function for release.
     */

  }, {
    key: "_getFirstReleaseFunction",
    value: function _getFirstReleaseFunction() {
      var _this = this;

      return function () {
        return _this._firstRelease();
      };
    }
    /**
     * First release.
     */

  }, {
    key: "_firstRelease",
    value: function _firstRelease() {
      this.isFinished = true;

      this._releaseAll();
    }
    /**
     * Release all promises.
     */

  }, {
    key: "_releaseAll",
    value: function _releaseAll() {
      this.list.forEach(function (fun) {
        return fun();
      });
      this.list = [];
    }
  }]);

  return Latch;
}();

exports.default = Latch;